

































import Vue from 'vue'
import axios from 'axios'
import { Component } from 'vue-property-decorator'
import moment from 'moment'
import { detect, BrowserName } from 'detect-browser'
import semver from 'semver'

import SectionBase from '@/mixins/SectionBase'
import ServiceSectionBase from './ServiceSectionBase'
import { Field } from '@/model/Field'
import { SET_SERVICE_ATTACHMENT } from '@/store/mod/service_form'

interface Data {
  browser: null | {
      name: BrowserName | "node";
      version: string;
      os: string;
  },
  numAttachments: number,
}

export default Vue.extend({
  mixins: [SectionBase, ServiceSectionBase],
  data (): Data {
    return {
      browser: null,
      numAttachments: 1,
    }
  },
  computed: {
    attachmentValidation (): string {
      const size = 'size:5120'

      if (this.browser && this.browser.name === 'ie' && semver.satisfies(this.browser.version, '10.x')) {
        return `ext:pdf,png,jpg,jpeg|${size}`
      } else {
        return `mimes:application/pdf,image/png,image/jpeg|${size}`
      }
    },
  },
  methods: {
    changeAttachment (name: string, file: File, attachmentNumber: number) {
      this.$store.commit('serviceForm/setAttachment', { index: attachmentNumber - 1, file })
      if (attachmentNumber >= this.numAttachments && this.numAttachments < 7) {
        this.numAttachments += 1;
      }
    },
  },
  created () {
    this.browser = detect()
  },
})
